export const MODUS_BUTTON_INVERSE_STYLESHEET = `
  .inverse-button {
    color: white !important;
  }
  .inverse-button:hover {
    background-color: rgba(255, 255, 255, 0.1) !important;
    color: white !important;
  }
`;
